var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEyeIcon = function SvgEyeIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 8C11 9.65685 9.65685 11 8 11C6.34315 11 5 9.65685 5 8C5 6.34315 6.34315 5 8 5C8.30747 5 8.60413 5.04625 8.88341 5.13218C8.36251 5.36736 8 5.89135 8 6.5C8 7.32843 8.67157 8 9.5 8C10.1087 8 10.6326 7.63749 10.8678 7.11659C10.9537 7.39587 11 7.69253 11 8Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14C2 14 0 8 0 8C0 8 2 2 8 2C14 2 16 8 16 8C16 8 14 14 8 14ZM2.1951 8.04307L2.17372 8L2.1951 7.95693C2.42604 7.49505 2.78373 6.88363 3.28644 6.28037C4.27954 5.08865 5.76219 4 8 4C10.2378 4 11.7205 5.08865 12.7136 6.28037C13.2163 6.88363 13.574 7.49505 13.8049 7.95693L13.8263 8L13.8049 8.04307C13.574 8.50495 13.2163 9.11637 12.7136 9.71963C11.7205 10.9113 10.2378 12 8 12C5.76219 12 4.27954 10.9113 3.28644 9.71963C2.78373 9.11637 2.42604 8.50495 2.1951 8.04307Z",
    fill: "black"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEyeIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/EyeIcon.7fedcdf0.svg";
export { ForwardRef as ReactComponent };